export default __webpack_public_path__ + "static/media/addUser.525015b2.png";